import { BUY_REPORT_TICKET } from "@/enum/amount/buy_report";

// 다방 매매 유입은 제휴 계약상 일반 매매리포트 한 상품만 판매한다.
export const DABANG_SALE_PRODUCT = Object.freeze({
  productCode: BUY_REPORT_TICKET.BASIC.productCode,
  orderType: BUY_REPORT_TICKET.BASIC.orderType,
  price: BUY_REPORT_TICKET.BASIC.unitPrice,
});

export const isDabangEntrySession = (routePath = "", entered = "") => {
  return routePath.startsWith("/dabang") || entered === "1";
};

export const canExposePremiumSaleProduct = isDabangSession => !isDabangSession;

export const getDabangPremiumUpgradeRedirect = (routePath = "", entered = "", query = {}) => {
  if (!isDabangEntrySession(routePath, entered)) {
    return null;
  }

  return {
    path: "/report/buy-renewed",
    query: { ...query },
  };
};
